import React from 'react';
import { SegmentProvider } from '@frameio/developer-components';
import './src/styles.css';

// eslint-disable-next-line import/prefer-default-export
export const wrapRootElement = ({ element }) => (
  <SegmentProvider segmentId={process.env.GATSBY_SEGMENT_ID}>
    {element}
  </SegmentProvider>
);